import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Signup, Education } from '@app/_models';
import { State } from '@app/_models/signups/geography';
import { SignupService } from '@app/_services';
import { FadvAlternateAlertComponent, FadvDatePickerComponent, FadvMenuComponent, FadvScrollerComponent } from '@fa-switch-sharedservices/ng-elements';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-education',
  templateUrl: './education.component.html',
  styleUrls: ['./education.component.less']
})
export class EducationComponent implements OnInit {

  @Input() formGroup: UntypedFormGroup;
  @Input() institutions: Education[];
  @Input() loading: boolean;
  @Input() levelsOfEducation: any;
  @Input() educationFormInvalid: boolean;
  @Input() states: State[];
  @Output() onRemove: EventEmitter<string[]> = new EventEmitter();
  @Output() onSubmit: EventEmitter<string> = new EventEmitter();
  @Output() diplomaAwarded: EventEmitter<boolean> = new EventEmitter();
  @Output() onCancel: EventEmitter<boolean> = new EventEmitter();
  @Output() enableValidators: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('fadvDatePickerStartDate') datePickerStartDate: FadvDatePickerComponent;
  @ViewChild('fadvDatePickerEndDate') datePickerEndDate: FadvDatePickerComponent;
  @ViewChild('fadvDatePickerAwardedDate') datePickerAwardedDate: FadvDatePickerComponent;
  @ViewChild('selectedLevelOfEducation') selectedLevelOfEducation!: FadvMenuComponent;
  @ViewChild('educationAlert') educationAlert!: FadvAlternateAlertComponent;
  disabled: boolean;
  institutionExists = false;
  subscription: Subscription;
  stateInvalid = false;
  cityInvalid = false;
  startDateInvalid = false;
  endDateInvalid = false;
  levelOfEducationInvalid = false;
  institutionNameInvalid = false;
  institutionInvalid = false;
  fieldOfStudyInvalid = false;
  nameAttendedUnderInvalid = false;
  today = new Date();
  typeOfDegreeInvalid = false;
  typesOfDegree: string[] = ["Diploma", "Certificate", "Associate", "Bachelor", "Master", "Doctorate"];
  levelOfEducation: string;
  showDegree = false;
  dateRecievedInvalid = false;
  enableAwardedDate = false;
  disableEducationButton = false;
  educationDataIsBad: boolean;

  constructor(private signupService: SignupService) { }

  ngOnInit(): void {
    // this.subscription = this.formGroup.valueChanges.subscribe(x => {
    //   if(this.formGroup.invalid)
    //   {
    //     this.educationFormInvalid = true;
    //   }
    //   else
    //   {
    //     this.educationFormInvalid = false;
    //   }

    //   if (this.institutions.length != 0 && this.disableEducationButton == true){
    //     this.enableValidators.emit(true);

    //     if(this.formGroup.valid){
    //       this.disableEducationButton = false;
    //     }
    //   }
    // })
  }

  // ngOnDestroy() {
  //   this.subscription.unsubscribe();
  // }

  handleShowDegree(degreeType: string){
    if(degreeType == "College"){
      this.showDegree = true;
    }
    else{
      this.showDegree = false;
    }
  }

  // removeEducation(institution: string, selectedLevelOfEducation: string) {
  //   var passedValues = [];
  //   passedValues.push(institution);
  //   passedValues.push(selectedLevelOfEducation);
  //   this.onRemove.emit(passedValues);
  // }

  // addEducation() {
  //   this.educationDataIsBad = false;
  //   var inputEmployer = new Education();
  //   inputEmployer = this.formGroup.value;
    
  //   inputEmployer.acquiredDegree = this.formGroup.controls.acquiredDegree.value;

  //   if(inputEmployer.acquiredDegree == false || inputEmployer.acquiredDegree == null){
  //     inputEmployer.dateAwarded = "Did not recieve degree";
  //     inputEmployer.acquiredDegree = false;
  //   }
  //   else{
  //     inputEmployer.acquiredDegree = true;
  //   }

  //   if(inputEmployer.levelOfEducation != "College"){
  //     inputEmployer.typeOfDegree = "NA"
  //   }

  //   Object.values(inputEmployer).forEach(x => {
  //     if (x === '' || x === null){
  //       this.educationDataIsBad = true;
  //       if(this.educationDataIsBad){
  //         this.educationAlert.show();
  //         return;
  //       }
  //     }
  //   })

  //   if(!this.educationDataIsBad){
  //     this.onSubmit.emit();
  //     this.enableAwardedDate = false;
  //     this.datePickerStartDate.value = null;
  //     this.datePickerEndDate.value = null;
  //     this.datePickerAwardedDate.value = null;
  //   }

  // }

  // cancel(){
  //   this.datePickerStartDate.value = null;
  //   this.datePickerEndDate.value = null;
  //   this.disableEducationButton = true;
  //   this.onCancel.emit(true);
  // }

  showValidation(field: string){
    if(this.formGroup.controls[field].invalid){
        this[field+"Invalid"] = true;
    }
    else{
        this[field+"Invalid"] = false;
    }
}

checkedAwardedBox(checked: boolean){
  this.enableAwardedDate = checked;
 }

 handleDateAwarded(event: any)
 {
   this.formGroup.controls.dateAwarded.setValue(event.target.value);
 }

 handleStartDate(event: any)
 {
   this.formGroup.controls.startDate.setValue(event.target.value);
 }

 handleEndDate(event: any)
 {
   this.formGroup.controls.endDate.setValue(event.target.value);
 }

}
